/**
 * Maps app locale (Redux / Locale enum value) to a BCP 47 language tag for `<html lang>`.
 */
export function localeToHtmlLang(locale) {
    if (locale == null) {
        return 'en';
    }
    const s = String(locale);
    if (s === 'en-test' || s === 'test') {
        return 'en';
    }
    return s.replace(/_/gu, '-');
}
